<template>
  <span>
    <img
      v-if="
        ['doc', 'DOC', 'docx', 'DOCX', 'docm', 'DOCM'].includes(
          isShowIcon(name)
        )
      "
      src="../images/translation/w-img.png"
      :width="size"
    />
    <img
      v-else-if="
        ['xls', 'XLS', 'xlsx', 'XLSX', 'xlsm', 'XLSM'].includes(
          isShowIcon(name)
        )
      "
      src="../images/translation/excel-img.png"
      :width="size"
    />
    <img
      v-else-if="['ppt', 'PPT', 'pptx', 'PPTX'].includes(isShowIcon(name))"
      src="../images/translation/ppt-img.png"
      :width="size"
    />
    <img
      v-else-if="['pdf', 'PDF'].includes(isShowIcon(name))"
      src="../images/translation/pdf-img.png"
      :width="size"
    />
    <img
      v-else-if="['srt', 'SRT'].includes(isShowIcon(name))"
      src="../images/translation/s-img.png"
      :width="size"
    />
    <img
      v-else-if="['txt', 'TXT'].includes(isShowIcon(name))"
      src="../images/translation/txt-img.png"
      :width="size"
    />
    <img
      v-else-if="['zip', 'rar', 'ZIP', 'RAR'].includes(isShowIcon(name))"
      src="../images/translation/zip-img.png"
      :width="size"
    />
    <img
      v-else-if="['csv', 'CSV'].includes(isShowIcon(name))"
      src="../images/translation/csv-img.png"
      :width="size"
    />
    <img
      v-else-if="['tmx', 'TMX'].includes(isShowIcon(name))"
      src="../images/translation/tmx-img.png"
      :width="size"
    />
    <img
      v-else-if="['tbx', 'TBX'].includes(isShowIcon(name))"
      src="../images/translation/tbx-img.png"
      :width="size"
    />
    <img
      v-else-if="
        ['jpg', 'JPG', 'jpeg', 'JPEG', 'gif', 'GIF', 'png', 'PNG'].includes(
          isShowIcon(name)
        )
      "
      src="../images/translation/img-img.png"
      :width="size"
    />
    <img
      v-else-if="['dxf', 'DXF'].includes(isShowIcon(name))"
      src="../images/translation/cad-img.png"
      :width="size"
    />
    <img
      v-else-if="['dwg', 'DWG'].includes(isShowIcon(name))"
      src="../images/translation/dwg-img.png"
      :width="size"
    />
    <img
      v-else-if="['json', 'JSON'].includes(isShowIcon(name))"
      src="../images/translation/json-img.png"
      :width="size"
    />
    <img
      v-else-if="['properties', 'PROPERTIES'].includes(isShowIcon(name))"
      src="../images/translation/prop-img.png"
      :width="size"
    />
    <img
      v-else-if="['yaml', 'YAML', 'yml', 'YML'].includes(isShowIcon(name))"
      src="../images/translation/yml-img.png"
      :width="size"
    />
    <img
      v-else-if="['sdltm', 'SDLTM'].includes(isShowIcon(name))"
      src="../images/translation/sdltm-img.png"
      :width="size"
    />
    <img
      v-else-if="['htm', 'HTM', 'html', 'HTML'].includes(isShowIcon(name))"
      src="../images/translation/html-img.png"
      :width="size"
    />
    <img
      v-else-if="
        [
          'sdlxliff',
          'SDLXLIFF',
          'xliff',
          'XLIFF',
          'mqxliff',
          'MQXLIFF',
        ].includes(isShowIcon(name))
      "
      src="../images/translation/sdl-img.png"
      :width="size"
    />
    <img v-else src="../images/translation/pro-img.png" :width="size" />
  </span>
</template>

<script>
  export default {
    props: {
      name: {
        type: String,
        default: '',
      },
      size: {
        default: '32',
      },
    },
    methods: {
      isShowIcon(name) {
        return name
          .substring(name.lastIndexOf('.') + 1, name.length)
          .toLowerCase()
      },
    },
  }
</script>

<style scoped>
  img {
    margin-right: 5px;
    vertical-align: sub;
  }
</style>
